<div class="global-header d-flex flex-column flex-sm-row p-1 bg-white border-bottom rounded" style="height: auto;">
    <div class="col-12">
        <ul class="nav custom-nav">
            <li class="nav-item">
                <a
                        class="nav-link"
                        [ngClass]="{'active': selectedTab === 'commande-fournisseur'}"
                        [routerLink]="['/tiers/fournisseurs/details', reference, 'detail-contenue-document', 'commande-fournisseur']"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        (click)="selectTab('commande-fournisseur')"
                >
                    <i data-feather="dollar-sign" class="nav-icon"></i>
                    Commande Fournisseur
                </a>
            </li>
            <li class="nav-item">
                <a
                        class="nav-link"
                        [ngClass]="{'active': selectedTab === 'facture-fournisseur'}"
                        [routerLink]="['/tiers/fournisseurs/details', reference, 'detail-contenue-document', 'facture-fournisseur']"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        (click)="selectTab('facture-fournisseur')"
                >
                    <i class="bi bi-cart-plus"></i> Facture fournisseur
                </a>
            </li>
            <li class="nav-item">
                <a
                        class="nav-link"
                        [ngClass]="{'active': selectedTab === 'bon-reception'}"
                        [routerLink]="['/tiers/fournisseurs/details', reference, 'detail-contenue-document', 'bon-reception']"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        (click)="selectTab('bon-reception')"
                >
                    <i class="bi bi-truck"></i> Bon de réception
                </a>
            </li>


        </ul>
        <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
